import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import { useIsMobile } from 'styles/hooks/mediaQueries';
import {
  Drawer,
  DrawerContentsWithOpenDelay,
  DrawerDismissButton,
  RouteDrawerCloseButton
} from 'catering/components/Drawers';
import { RouteModal } from 'catering/components/Modals';
import { getPageBackgroundColor } from 'styles/helpers/getThemeStyles';

const StyledDrawerContentsWithOpenDelay = styled(DrawerContentsWithOpenDelay)(
  ({ theme }) => {
    return {
      '& .MuiDrawer-paper': {
        width: 400,
        padding: 0,
        backgroundColor: getPageBackgroundColor(theme)
      }
    };
  }
);

export function RouteDrawer(props) {
  const isMobile = useIsMobile();

  // We can pass in additional props to RouteModal using RouteModalProps
  const {
    children,
    displayDismissButton = true,
    DrawerDismissButtonProps = {},
    onClose,
    RouteModalProps = {},
    ...rest
  } = props;

  if (isMobile) {
    return (
      <RouteModal
        displayDismissButton={displayDismissButton}
        onClose={onClose}
        {...RouteModalProps}
      >
        {children}
      </RouteModal>
    );
  }

  return (
    <Drawer>
      <StyledDrawerContentsWithOpenDelay onClose={onClose} {...rest}>
        {displayDismissButton && (
          <DrawerDismissButton>
            <RouteDrawerCloseButton
              onClick={onClose}
              {...DrawerDismissButtonProps}
            />
          </DrawerDismissButton>
        )}
        {children}
      </StyledDrawerContentsWithOpenDelay>
    </Drawer>
  );
}

RouteDrawer.propTypes = {
  children: CHILDREN_PROP_TYPES.isRequired,
  displayDismissButton: PropTypes.bool,
  DrawerDismissButtonProps: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  RouteModalProps: PropTypes.object
};
